var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMietUndWohnungseigentumsrecht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163.44 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00355b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.91,32.6v-11.93c.42-5.37,2.52-5.05,4.7-5.75,1.84-.58,8.46-.6,10.42-.22,3.06.59,5.67.13,5.52,6.35l.02,28.36c.06.22.95.91,1.2,1.12,5.36,4.59,12.79,9.46,17.92,14.21,2.7,2.49-2.69,11.73-4.25,11.73h-7.87l-.19.19v77.15c.19,11.12-2.05,12.15-13.22,12.19H26.34c-11.91-.39-13.62-1.93-13.47-12.19v-77.15l-.19-.19h-7.87c-.26,0-6.99-7.98-4.07-11.29C26.27,43.95,52.11,23.05,77.81,2.02c4.08-2.75,4.54-2.71,7.93.21l37.16,30.37ZM46.38,90.3c-1.59.01-5.97,4.79-6,6.61s5.33,7.14,6.74,7.16h69.02c1.55-.04,6.7-5.19,6.74-6.9s-5.04-6.92-6.23-6.9l-70.27.03ZM46.9,117.78c-1.82-.06-6.46,4.49-6.52,6.73-.06,1.97,4.53,6.95,6.23,7.04h70.05c2.28-.09,6.23-5.35,6.23-7.1,0-1.91-4.58-6.6-6.74-6.7l-69.24.04Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMietUndWohnungseigentumsrecht);
export default __webpack_public_path__ + "static/media/MietUndWohnungseigentumsrecht.d4b53d4be21ad12dbf856e52882c0fdd.svg";
export { ForwardRef as ReactComponent };